import { useTranslation } from 'react-i18next';
import { LightbulbIcon, LightbulbOffIcon } from 'lucide-react';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@monksflow/monks-ui';
import { useChatActions } from '@/features/chats/stores';
import { useSuggestionsHidden } from '../../model/suggestionsVisibility/suggestionsVisibility.store';
import { useAgentOffersSuggestions } from '../../model/useChatSuggestions';

/** The composer's lightbulb: shows or hides the suggestions above it. */
export function ChatSuggestionsToggle({ disabled = false }: { disabled?: boolean }) {
  const { t } = useTranslation('chats');
  const offers = useAgentOffersSuggestions();
  const [hidden, setHidden] = useSuggestionsHidden();
  const { catchUpSuggestions } = useChatActions();

  if (!offers) return null;

  const label = hidden ? t('chats.chatSuggestions.show') : t('chats.chatSuggestions.hide');
  const toggle = () => {
    setHidden(!hidden);
    if (hidden) void catchUpSuggestions();
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 rounded-lg"
          aria-label={label}
          aria-pressed={!hidden}
          onClick={toggle}
          disabled={disabled}
        >
          <span className="toolbar-icon-hover">
            {hidden ? (
              <LightbulbOffIcon className="h-4 w-4" />
            ) : (
              <LightbulbIcon className="h-4 w-4" />
            )}
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{label}</p>
      </TooltipContent>
    </Tooltip>
  );
}
